import { Button, Grid2 } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { FC } from 'react';
import { LoadingButton } from './LoadingButton';

interface AvaniButtonProps {
  onClick?: any;
  loading: boolean;
  label: string;
  Grid?: boolean;
  disabled?: boolean;
  type?: 'submit' | 'button' | 'reset';
  variant?: 'contained' | 'outlined' | 'text' | undefined;
  size?: 'small' | 'medium' | 'large';
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  fullWidth?: boolean;
  sx?: any;
}

const StyledButton = styled(Button)(
  ({ theme }) => `
  .MuiButtonBase-root {
    border-radius: 50%;
    border: 2px solid #333333!important;
  }
  `
);

export const AvaniButton: FC<AvaniButtonProps> = ({
  onClick,
  label,
  disabled,
  loading,
  Grid = false,
  variant = 'contained',
  type = 'button',
  size = 'large',
  color = 'primary',
  fullWidth = false,
  sx = {}
}) => {
  const controlElement = loading ? (
    <>
      <LoadingButton
        {...(onClick ? { onClick: onClick } : {})}
        loading={loading}
        sx={{ mx: 1, px: 3, ...sx }}
        type={type}
        variant={variant}
        size={size}
        disabled={disabled}
        color={color}
        fullWidth={fullWidth}
      >
        {label}
      </LoadingButton>
    </>
  ) : (
    <>
      <StyledButton
        {...(onClick ? { onClick: onClick } : {})}
        sx={{ mx: 1, px: 3, ...sx }}
        type={type}
        variant={variant}
        size={size}
        disabled={disabled}
        color={color}
        fullWidth={fullWidth}
      >
        {label}
      </StyledButton>
    </>
  );

  return Grid ? (
    <Grid2
      size={{
        xs: 6
      }}
    >
      {controlElement}
    </Grid2>
  ) : (
    controlElement
  );
};
